import { cn } from '@/lib/utils'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { CampaignShortItem } from '@intone/shared/types'

const ALL_CAMPAIGNS_VALUE = '__all__'

export interface CampaignSelectorProps {
  campaigns: CampaignShortItem[]
  selectedCampaignId: number | null
  onCampaignChange: (campaignId: number | null) => void
  className?: string
  disabled?: boolean
  showAllOption?: boolean
}

export function CampaignSelector({
  campaigns,
  selectedCampaignId,
  onCampaignChange,
  className,
  disabled,
  showAllOption,
}: CampaignSelectorProps) {
  return (
    <Select
      value={selectedCampaignId ? String(selectedCampaignId) : showAllOption ? ALL_CAMPAIGNS_VALUE : undefined}
      onValueChange={(v) => {
        if (v === ALL_CAMPAIGNS_VALUE) {
          onCampaignChange(null)
        } else {
          onCampaignChange(parseInt(v, 10))
        }
      }}
      disabled={disabled || campaigns.length === 0}
    >
      <SelectTrigger className={cn('h-9', className)}>
        <SelectValue placeholder="Select a campaign" />
      </SelectTrigger>
      <SelectContent>
        {showAllOption && (
          <SelectItem value={ALL_CAMPAIGNS_VALUE}>All campaigns</SelectItem>
        )}
        {campaigns.map((c) => (
          <SelectItem key={c.id} value={String(c.id)}>
            {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
